<template>
  <div class="small">
    <div class="logoandtext large">
      <div class="label_tot guida_color">
        GUIDA TOT. {{ minToString(total.guida_tot) }}
      </div>
      <div class="label_tot riposo_color">
        RIPOSO TOT. {{ minToString(total.riposo_tot) }}
      </div>
      <div class="label_tot lavoro_color">
        LAVORO TOT. {{ minToString(total.lavoro_tot) }}
      </div>
      <div class="label_tot disp_color">
        DISPONIBILE TOT. {{ minToString(total.disp_tot) }}
      </div>
      <div class="label_tot err_color">
        ERRORE TOT. {{ minToString(total.err_tot) }}
      </div>
    </div>
  </div>
</template>

<script>
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
export default {
  name: 'TimetableCardTotal',
  mixins: [UtilityMixin],
  props: {
    total: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {}
  },

  mounted() {},
}
</script>
<style scoped>
.small {
  font-size: 10px;
  line-height: 6px;
  font-weight: bold;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.large {
  font-size: 14px;
}

.riposo_color {
  color: green;
}

.lavoro_color {
  color: blue;
}

.guida_color {
  color: red;
}

.disp_color {
  color: orange;
}

.err_color {
  color: black;
}
.logoandtext {
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
}
.logoandtext .img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 48px;
}

.logoandtext .img-container img {
  max-height: 32px;
}

.logoandtext .text-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  font-size: 14px;
}

.label_tot {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  font-size: 10px;
}
</style>
